// extracted by mini-css-extract-plugin
export default {"root":"chats-module___root___da4cf9f1"};